<template>
  <v-flex>
    <v-flex v-for="(line, index) in lines" :key="index">
      <v-chip :color="line.left.characterColor">{{ line.left.characterName }}</v-chip>
      <span> to </span>
      <v-chip :color="line.right.characterColor">{{ line.right.characterName }}</v-chip>
      <span>: {{ line.msg }}</span>
    </v-flex>
  </v-flex>
  </template>
<script>
export default {
  props: ['nodeId', 'storyID'],
  data () {
    return {
      lines: [],
      allLines: []
    }
  },
  components: {
  },
  mounted () {
    this.receiveMessageFromBottomBlock()
  },
  watch: {
    nodeId () {
      this.lines = this.allLines.filter(line => line.nodeId === this.nodeId)
    }
  },
  methods: {
    receiveMessageFromBottomBlock () {
      this.$root.$on('messageFromBottomBlock', (message, leftCharacterName, rightCharacterName, trigger) => {
        let eachLine = {}
        if (trigger) {
          eachLine = {nodeId: this.nodeId, left: leftCharacterName, right: rightCharacterName, msg: message, trigger: trigger}
          this.$root.$emit('triggerTextFromChatArea', eachLine)
        } else {
          eachLine = {nodeId: this.nodeId, left: leftCharacterName, right: rightCharacterName, msg: message}
        }
        this.allLines.push(eachLine)
        this.lines = this.allLines.filter(line => line.nodeId === this.nodeId)
        // this.saveConversation()
      })
    }
    // saveConversation () {
    //   let updates = {}
    //   updates[`${this.storyID}`] = {conversations: this.allLines}
    //   storiesRef.ref().update(updates)
    //     .then(snapshot => {
    //       console.log('Conversation saved in ', this.storyID)
    //     })
    // }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/story-edit-view/conversation/chatArea.vue